export const Base_url = 'https://dummyjson.com';
// export const Base_url = 'http://localhost:3002/api/v1';
// export const Base_url = 'https://shopping-cart-api-production.up.railway.app//api/v1';
// export const image_url = 'https://shopping-cart-api-production.up.railway.app/';
export const image_url = 'http://localhost:3002';